import React, { useEffect, useMemo, useState, useRef, useCallback } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Layout, Row, Col, Card, Button, ConfigProvider, Divider, message, Spin } from 'antd';
import SubnavBar from '../subnav_bar/SubnavBar';
import {
	nullSafeGet,
	nullSafeGetOrElse,
	getStartDateFieldName,
	getEndDateFieldName,
	getEntitiesByIdWithSearch,
	isSupplierPayingCustomer,
} from '../../utils/DataAccessUtils';
import {
	workOrderPrioritiesRestCrudThunksForBuyer,
	workOrderPrioritiesRestCrudThunksForSupplier,
} from '../../thunks/work_order_priorities_thunks';
import {
	fetchAllFieldTechs,
	fieldTechsRestCrudThunksForBuyer,
	fieldTechsRestCrudThunksForSupplier,
} from '../../thunks/field_techs_thunks';
import {
	assetTypesRestCrudThunksForBuyer,
	assetTypesRestCrudThunksForSupplier,
} from '../../thunks/asset_types_thunks';
import {
	resolutionTypesRestCrudThunksForBuyer,
	resolutionTypesRestCrudThunksForSupplier,
} from '../../thunks/resolution_types_thunks';
import {
	plannedMaintenanceSchedulesRestCrudThunksForBuyer,
	plannedMaintenanceSchedulesRestCrudThunksForSupplier,
} from '../../thunks/planned_maintenance_schedules_thunks';
import { assetsRestReadThunk } from '../../thunks/assets_thunks';
import {
	ContractorPrivateNetworksRestCrudThunksForBuyer,
	ContractorPrivateNetworksRestCrudThunksForSupplier,
} from '../../thunks/contractors_private_networks_thunks';
import { fetchDistinctAreasHeirarchy } from '../../thunks/areas_thunks';
import {
	contractorClientsRestCrudThunksForBuyer,
	contractorClientsRestCrudThunksForSupplier,
} from '../../thunks/contractor_clients_thunks';
import {
	contractorLocationsRestCrudThunksForBuyer,
	contractorLocationsRestCrudThunksForSupplier,
} from '../../thunks/contractor_locations_thunks';
import {
	problemTypesHeirarchicalForBuyer,
	problemTypesHeirarchicalForSupplier,
} from '../../thunks/problem_types_thunks';
import {
	fetchSupplierFacilitiesInPrivateNetworkForBuyer,
	fetchSupplierFacilitiesInPrivateNetworkForSupplier,
} from '../../thunks/supplier_facilities_thunks';
import {
	spendCategoriesRestCrudThunksForBuyer,
	spendCategoriesRestCrudThunksForSupplier,
} from '../../thunks/spend_categories_thunks';
import {
	getContactsForThirdPartySuppliers,
	getContactsWithInternalTechs,
} from '../../thunks/contacts_thunks';
import EventCalendar from '../event_calendar/EventCalendar';
import stackingLayout from '../event_calendar/stackingLayout';
import { getFieldTechDisplayName } from '../../utils/FieldTechUtils';
import {
	capitalize,
	formatDateForParam,
	isDatePastDue,
	formatDateForLocationTimeZone,
} from '../../utils/DataFormatterUtils';
import moment from 'moment-timezone';
import SelectedFilters from '../selected_filters_pills/SelectedFilters';
import { FILTER_CONFIG_NAMES } from '../../utils/DataConstants';
import {
	fetchWorkOrders,
	updateFiltersWorkOrders,
	clearFiltersWorkOrders,
} from '../../thunks/work_orders_thunks_wrapper';
import {
	rescheduleServiceCallForSupplier,
	scheduleServiceCallForSupplier,
	workOrdersRestCrudThunksForBuyer,
	workOrdersRestCrudThunksForSupplier,
} from '../../thunks/work_orders_thunks';
import {
	getSanitisedWorkOrder,
	getWorkOrderArchivalKey,
	BUYER_WO_FILTERS_ORDER,
	INTERNAL_SERVICE_TEAM_WO_FILTERS_ORDER,
	isAValidAndParitalWorkOrder,
	getServiceCallLeadTechnicianEmail,
	PAYING_SUPPLIER_WO_FILTER_ORDER,
	THIRD_PARTY_SUPPLIER_WO_FILTERS_ORDER,
} from '../../utils/WorkOrderUtils';
import { ROLE_TYPES } from '../../utils/DataConstants';
import { Views, momentLocalizer } from 'react-big-calendar';
import AssignedFilters from '../WorkOrderTable/AssignedFilters';
import { ASSIGNED_FILTERS } from '../WorkOrderTable/config/assigned';
import WorkOrderTable from '../WorkOrderTable';
import {
	ArrowLeftOutlined,
	CaretDownFilled,
	CloseOutlined,
	FullscreenOutlined,
} from '@ant-design/icons';
import { Sorter } from '../WorkOrderTable/sorters/Sorters';
import { WORK_ORDER_SORTERS } from '../WorkOrderTable/config/sorters/sorters';
import ServiceCalendarWorkOrderRow from './ServiceCalendarWorkOrderRow';
import {
	useBuyerFilterConfiguration,
	useCommonFilterConfiguration,
	useSupplierFilterConfiguration,
} from '../../hooks/workOrderHooks';
import {
	brandsRestCrudThunksForBuyer,
	brandsRestCrudThunksForSupplier,
} from '../../thunks/brands_thunks';
import { EmptyState } from '../empty_state/EmptyState';
import ScheduleServiceCallModalForm from '../schedule_service_call_modal_form/ScheduleServiceCallModalForm';
import OWSearchInput from '../common/OWSearchInput';
import { createSelector } from 'reselect';
import { withCurrentUser } from '../../hooks/withCurrentUser';
import useMountEffect from '../../hooks/useMountEffect';
import { WORK_ORDER_DISPLAY_STATUSES } from '../../constants/WorkOrderDisplayStatuses';
import { withUserType } from '../withUserType';
import {
	WORK_ORDER_STATUSES,
	TECH_SCHEDULED_STATUSES,
	SCHEDULE_TECH_STATUSES,
} from '../../constants/WorkOrderStatuses';
import Filters from '../WorkOrderTable/filters/filters';
import { isBuyerOrInternalTech, isInternalTech } from '../../utils/AuthUtils';

import CustomCalendarToolbar from '../event_calendar/CustomCalendarToolbar';
import {
	CALENDAR_COMPONENTS,
	CalendarRightNav,
	TechnicianColumnHeader,
	TechnicianNavContext,
} from './TechnicianColumnHeader';
import { TechnicianFilterPopover } from './TechnicianFilterPopover';
import { cn } from '../../utils/ClassNamesUtils';
import { AppointmentCard } from './AppointmentCard';
import { LocationColumnHeader, LocationIdentity } from './LocationColumnHeader';
import { LocationFilterPopover } from './LocationFilterPopover';
import {
	fetchLocationsWithRegionsAndSubRegions,
	locationsRestCrudThunks,
} from '../../thunks/locations_thunks';
import { SUBCONTRACTED_FILTERS } from '../WorkOrderTable/config/subcontracted';
import SubcontractedFilters from '../WorkOrderTable/SubContractedFilters';
import {
	SUPER_ADMIN,
	SUPPLIER_ACCOUNTING_MANAGER,
	SUPPLIER_ADMIN,
	SUPPLIER_INVENTORY_MANAGER,
	SUPPLIER_MANAGER,
	SUPPLIER_TECH,
} from '../roles/roles';

const { Content } = Layout;
const WORK_ORDERS_CALENDAR_TARGET_COLLECTION = 'workOrdersCalendarIndex';
const WORK_ORDERS_SCHEDULE_TARGET_COLLECTION = 'workOrdersScheduleIndex';
const LAST_SERVICE_CALL_SCHEDULED_AT_FIELD = FILTER_CONFIG_NAMES.LAST_SERVICE_CALL_SCHEDULED_AT;
const SERVICE_CALENDAR_TECHNICIANS_TARGET_COLLECTION = 'serviceCalendarTechnicians';
// The flat list of locations the buyer can access — the source of the columns and of the picker's
// checkbox list.
const SERVICE_CALENDAR_LOCATIONS_TARGET_COLLECTION = 'serviceCalendarLocations';
// The picker's tree needs the region hierarchy — a different endpoint and shape (regions at the top
// level, locations nested underneath). It shares the collection the work order filter drawer's
// location tree already uses: same endpoint, so nothing to register and nothing to trample. The
// hierarchy itself is kept in component state, not read back from this collection, because the
// endpoint writes region records into the same `records` map as locations and the two id spaces can
// collide.
const LOCATION_TREE_TARGET_COLLECTION = 'workOrdersAdvancedFilters';
const MAX_VISIBLE_TECHNICIAN_COLUMNS = 4;
const DAY_VIEW_FETCH_BATCH_SIZE = 5;
const CALENDAR_PAGE_SIZE = 1000;

const CALENDAR_COLUMN_FILTER_KEYS = ['fieldTechnicianEmails', 'locationIds'];

// Handle the gone filters because these params might still be saved in URLs with customers.
const UNSUPPORTED_CALENDAR_QUERY_PARAMS = [
	'current',
	'pageSize',
	'displayStatus',
	'status',
	'displayStatuses',
	'statuses',
	...CALENDAR_COLUMN_FILTER_KEYS,
];

const createUrlSanitizingHistory = (history) => {
	if (!history) return history;
	const stripKeys = (url) => {
		if (typeof url !== 'string' || url.indexOf('?') === -1) {
			return url;
		}
		const [pathname, search] = url.split('?');
		const params = new URLSearchParams(search);
		let changed = false;
		CALENDAR_COLUMN_FILTER_KEYS.forEach((key) => {
			if (params.has(key)) {
				params.delete(key);
				changed = true;
			}
		});
		if (!changed) return url;
		const nextSearch = params.toString();
		return nextSearch ? `${pathname}?${nextSearch}` : pathname;
	};
	return new Proxy(history, {
		get(target, prop, receiver) {
			if (prop === 'replace' || prop === 'push') {
				return (url, ...rest) => target[prop](stripKeys(url), ...rest);
			}
			const value = Reflect.get(target, prop, receiver);
			return typeof value === 'function' ? value.bind(target) : value;
		},
	});
};
const START_TIME_ONLY_EVENT_STATUSES = ['Scheduled', 'PastDue', 'CheckedIn'];
export const encodeUTCAdjustedDateWithUserTimeZone = (
	date,
	isEndOfDay = false,
	timeZone = moment.tz.guess()
) => {
	const local = moment(date).tz(timeZone, true);
	if (date) {
		return isEndOfDay ? local.clone().endOf('day').utc() : local.clone().startOf('day').utc();
	}
	return undefined;
};

// The span the calendar actually draws, as local moments.
const getViewRange = (view, date) => {
	const isWeekView = view === Views.WEEK;
	return {
		viewStart: isWeekView
			? moment(date).startOf('week').isoWeekday(1).startOf('day')
			: moment(date).startOf('day'),
		viewEnd: isWeekView
			? moment(date).endOf('week').isoWeekday(7).endOf('day')
			: moment(date).endOf('day'),
	};
};

const toCalendarZoneScrollTime = (instant, timeZone) => {
	if (!instant || !timeZone) return instant;
	const wall = moment.tz(instant, timeZone);
	const localMatched = new Date(instant.getTime ? instant.getTime() : new Date(instant).getTime());
	localMatched.setHours(wall.hour(), wall.minute(), wall.second(), wall.millisecond());
	return localMatched;
};

// A manager or admin who also carries SUPPLIER_TECH must not be treated as a field technician,
// otherwise the calendar restrictions strip their picker and team-wide controls.
const ELEVATED_SUPPLIER_ROLES = new Set<string>([
	SUPER_ADMIN,
	SUPPLIER_ADMIN,
	SUPPLIER_MANAGER,
	SUPPLIER_INVENTORY_MANAGER,
	SUPPLIER_ACCOUNTING_MANAGER,
]);

// Role-only, deliberately: this page is reachable by third-party suppliers as well as internal
// service teams, so pairing this with isInternalTech would leave a third-party supplier's technician
// seeing the whole team's calendar.
export const isFieldTech = (currentUser) => {
	const roles = nullSafeGetOrElse('roles', currentUser, []);
	return (
		roles.some((role) => role === SUPPLIER_TECH) &&
		!roles.some((role) => ELEVATED_SUPPLIER_ROLES.has(role))
	);
};

// A service call checked into in an earlier week and never checked out is still running, so it
// belongs on this view — but the API filters on serviceScheduledAt, which for that call sits before
// this view starts, so it is never returned. Ask for the preceding week as well and let
// transformRecords drop whatever does not reach into the view. Only the start is widened: the end
// already bounds what can be relevant. A call still running from further back than this stays
// missing, which is the limit of filtering on the scheduled date alone.
const CALENDAR_LOOKBACK_DAYS = 7;

const calculateDateRangeForView = (view, date, timeZone = moment.tz.guess()) => {
	const { viewStart, viewEnd } = getViewRange(view, date);
	const fetchStart = viewStart.clone().subtract(CALENDAR_LOOKBACK_DAYS, 'days');

	return {
		startDate: formatDateForParam(
			encodeUTCAdjustedDateWithUserTimeZone(fetchStart, false, timeZone)
		),
		endDate: formatDateForParam(encodeUTCAdjustedDateWithUserTimeZone(viewEnd, true, timeZone)),
	};
};

const selectCalendarWorkOrders = createSelector(
	(state: any) => state.work_orders,
	(workOrdersSlice) =>
		getEntitiesByIdWithSearch(
			nullSafeGetOrElse(
				`${WORK_ORDERS_CALENDAR_TARGET_COLLECTION}.recordsIds`,
				workOrdersSlice,
				[]
			),
			workOrdersSlice
		)
);

const selectCalendarTechnicians = createSelector(
	(state: any) => state.field_techs,
	(fieldTechsSlice) =>
		getEntitiesByIdWithSearch(
			nullSafeGetOrElse(
				`${SERVICE_CALENDAR_TECHNICIANS_TARGET_COLLECTION}.recordsIds`,
				fieldTechsSlice,
				[]
			),
			fieldTechsSlice
		)
);

// The locations the buyer's tree select has fetched. Memoized for the same reason as the
// technicians above: getEntitiesByIdWithSearch builds a new array per call.
const selectCalendarLocationOptions = createSelector(
	(state: any) => state.locations,
	(locationsSlice) =>
		getEntitiesByIdWithSearch(
			nullSafeGetOrElse(
				`${SERVICE_CALENDAR_LOCATIONS_TARGET_COLLECTION}.recordsIds`,
				locationsSlice,
				[]
			),
			locationsSlice
		)
);

require('./SupplierServiceCallCalendarPage.less');

const CALENDAR_TOOLBAR_VIEWS = [Views.WEEK, Views.DAY];

const SupplierServiceCallCalendarPageV2 = (props: any) => {
	const {
		workOrders,
		data,
		fetchData,
		updateFilters: updateFiltersProp,
		clearFilters,
		fetchLocations,
		fetchWorkOrderPriorities,
		fetchMultipleFieldTechs,
		fetchFieldTechs,
		locations,
		workOrderPriorities,
		fieldTechs,
		location,
		currentUser,
		spendCategories,
		fetchSpendCategories,
		fetchMultipleSpendCategories,
		contractorPrivateNetworks,
		fetchContractors,
		contractorClients,
		fetchContractorClients,
		fetchMultipleContractorClients,
		contractorLocations,
		fetchContractorLocations,
		fetchMultipleContractorLocations,
		users,
		fetchUsers,
		fetchMultipleUsers,
		areas,
		fetchAreasDistinct,
		assets,
		fetchAssets,
		fetchMultipleAssets,
		assetTypes,
		fetchAssetTypes,
		fetchMultipleAssetTypes,
		planned_maintenance_schedules,
		fetchPMSchedule,
		fetchMultiplePMSchedule,
		problemTypes,
		fetchProblemTypes,
		supplierFacilities,
		fetchSupplierFacilitiesInPrivateNetwork,
		resolutionTypes,
		fetchResolutionTypes,
		fetchMultipleResolutionTypes,
		companyConfig,
		rescheduleServiceCall,
		scheduleServiceCall,
		getFullWorkOrder,
		syncScheduleTechnicianFilter,
		technicians,
		technicianCount,
		fetchAllFieldTechs,
		userType,
		calendarLocationOptions,
		fetchCalendarLocations,
		fetchLocationTree,
		brands,
		fetchBrands,
		fetchMultipleBrands,
	} = props;

	// Buyers get the same calendar with a column per location instead of per technician. The two
	// roles have separate builds and role-prefixed routes, so the session's userType is also the
	// route's role — no extra prop needed to tell the views apart.
	const isLocationView = userType === ROLE_TYPES.BUYER;
	const resourceKeyField = isLocationView ? 'id' : 'email';
	const resourceAccessorField = isLocationView ? 'locationIds' : 'technicianEmails';

	const { fetching, pagination } = workOrders;

	const [showScheduleWOs, setShowScheduleWOs] = useState(false);
	const [isFullscreen, setIsFullscreen] = useState(false);
	// Legend chip acting as a filter, or null for all. Filtered here rather than through the search
	// API on purpose: eventStatus is derived below from displayStatus, status, the service call's
	// check-in/out times and dueDate together, and only two of the five buckets have an equivalent
	// `statuses` filter — Checked In and the Scheduled/Past Due split have none. Reusing the same
	// derivation is what keeps a chip and the colour beside it showing the same work orders.
	const [selectedEventStatuses, setSelectedEventStatuses] = useState<string[]>([]);
	const overlayRef = useRef<HTMLDivElement | null>(null);
	const [rescheduleModalVisible, setRescheduleModalVisible] = useState(false);
	const [scheduleModalVisible, setScheduleModalVisible] = useState(false);
	const [selectedWorkOrder, setSelectedWorkOrder] = useState(null);
	const [newScheduledTime, setNewScheduledTime] = useState(null);
	const [isLoadingFullWorkOrder, setIsLoadingFullWorkOrder] = useState(false);
	const [calendarDate, setCalendarDate] = useState(new Date());
	const [calendarView, setCalendarView] = useState<string>(Views.DAY);
	const [scrollToTime, setScrollToTime] = useState(new Date());
	const [technicianSelection, setTechnicianSelection] = useState<string[]>(null);
	const [visibleTechnicianOffset, setVisibleTechnicianOffset] = useState(0);
	const calendarScrollApiRef = useRef<{
		scrollByColumns: (delta: number) => void;
		scrollToColumn: (index: number) => void;
	} | null>(null);
	const [weekTechnicianIndex, setWeekTechnicianIndex] = useState(0);
	const [dropTechnicianEmail, setDropTechnicianEmail] = useState(null);
	const rescheduleFormRef = useRef(null);
	const scheduleFormRef = useRef(null);

	// Calculate staleDays from companyConfig
	const staleDays = useMemo(
		() => nullSafeGetOrElse('config.workOrder.stale.afterXDays', companyConfig, 14),
		[companyConfig]
	);
	const isInternalTeam = isInternalTech(currentUser);
	const currentUserEmail = nullSafeGet('email', currentUser);

	const isFieldTechnicianUser = isFieldTech(currentUser);

	// Technicians come from the roster; locations come from the work orders themselves, so the
	// location view needs no roster fetch. A location whose only service call sits in the lookback
	// week shows an empty column, the same way a technician with nothing scheduled does.
	const locationResources = useMemo(() => {
		if (!isLocationView) {
			return [];
		}
		const byId = {};
		(data || []).forEach((workOrder) => {
			const locationId =
				nullSafeGet('locationId', workOrder) || nullSafeGet('location.id', workOrder);
			if (!locationId || byId[locationId]) {
				return;
			}
			byId[locationId] = {
				...nullSafeGetOrElse('location', workOrder, {}),
				id: locationId,
			};
		});
		return Object.keys(byId)
			.map((locationId) => byId[locationId])
			.sort((first, second) =>
				`${nullSafeGetOrElse('name', first, '')}`.localeCompare(
					`${nullSafeGetOrElse('name', second, '')}`
				)
			);
	}, [data, isLocationView]);

	// What the picker can name: everything the tree select has fetched (the buyer's accessible
	// locations), plus the ones already on the calendar in case a column's record has not been
	// fetched into that collection.
	const locationPickerOptions = useMemo(() => {
		if (!isLocationView) {
			return [];
		}
		const byId = {};
		[...locationResources, ...(calendarLocationOptions || [])].forEach((location) => {
			const locationId = nullSafeGet('id', location);
			if (locationId && !byId[locationId]) {
				byId[locationId] = location;
			}
		});
		return Object.keys(byId)
			.map((locationId) => byId[locationId])
			.sort((first, second) =>
				`${nullSafeGetOrElse('name', first, '')}`.localeCompare(
					`${nullSafeGetOrElse('name', second, '')}`
				)
			);
	}, [isLocationView, locationResources, calendarLocationOptions]);

	// One pipeline for both views. Everything downstream — the lookup, the ordering, the column
	// paging, the week-view scoping — only needs a stable key per column, so the records and the key
	// field are chosen once here. The `technician`-flavoured names are the supplier case.
	//
	const calendarResources = isLocationView ? locationPickerOptions : technicians;

	const techniciansByEmail = useMemo(() => {
		const lookup = {};
		(calendarResources || []).forEach((resource) => {
			const resourceKey = nullSafeGet(resourceKeyField, resource);
			if (resourceKey) {
				lookup[resourceKey] = resource;
			}
		});
		return lookup;
	}, [calendarResources, resourceKeyField]);

	const defaultTechnicianEmails = useMemo(
		() =>
			(calendarResources || [])
				.map((resource) => nullSafeGet(resourceKeyField, resource))
				.filter(Boolean),
		[calendarResources, resourceKeyField]
	);

	const orderedTechnicianEmails = useMemo(() => {
		return isFieldTechnicianUser
			? [currentUserEmail]
			: technicianSelection || defaultTechnicianEmails;
	}, [isFieldTechnicianUser, currentUserEmail, technicianSelection, defaultTechnicianEmails]);

	const orderedTechnicians = useMemo(
		() =>
			orderedTechnicianEmails.map((resourceKey) => techniciansByEmail[resourceKey]).filter(Boolean),
		[orderedTechnicianEmails, techniciansByEmail]
	);

	const orderedTechEmailsKey = useMemo(
		() => orderedTechnicianEmails.join(','),
		[orderedTechnicianEmails]
	);

	const [fetchedColumns, setFetchedColumns] = useState<{ columnSetKey: string; ids: string[] }>({
		columnSetKey: '',
		ids: [],
	});

	const computeVisibleColumnFilter = useCallback((): object => {
		if (isFieldTechnicianUser || calendarView !== Views.DAY) {
			return {};
		}
		const start = Math.min(
			visibleTechnicianOffset,
			Math.max(0, orderedTechnicianEmails.length - MAX_VISIBLE_TECHNICIAN_COLUMNS)
		);
		const fetchCount =
			orderedTechnicianEmails.length > MAX_VISIBLE_TECHNICIAN_COLUMNS
				? MAX_VISIBLE_TECHNICIAN_COLUMNS + 1
				: MAX_VISIBLE_TECHNICIAN_COLUMNS;
		const visibleKeys = orderedTechnicianEmails.slice(start, start + fetchCount).filter(Boolean);
		if (visibleKeys.length === 0) {
			return {};
		}
		return isLocationView
			? { locationIds: visibleKeys.join(',') }
			: { fieldTechnicianEmails: visibleKeys.join(',') };
	}, [
		isFieldTechnicianUser,
		calendarView,
		isLocationView,
		visibleTechnicianOffset,
		orderedTechnicianEmails,
	]);

	const getActiveColumnFilter = useCallback((): object => {
		const key = isLocationView ? 'locationIds' : 'fieldTechnicianEmails';
		if (calendarView === Views.WEEK) {
			const activeFilters = nullSafeGetOrElse('filters', workOrders, {});
			const value = activeFilters[key];
			return value ? { [key]: value } : {};
		}
		return fetchedColumns.ids.length > 0 ? { [key]: fetchedColumns.ids.join(',') } : {};
	}, [calendarView, fetchedColumns.ids, isLocationView, workOrders]);

	const updateFilters = useCallback(
		(newFilters) => {
			if (calendarView !== Views.DAY || fetchedColumns.ids.length === 0) {
				return updateFiltersProp(newFilters);
			}
			if (
				newFilters &&
				(Object.prototype.hasOwnProperty.call(newFilters, 'fieldTechnicianEmails') ||
					Object.prototype.hasOwnProperty.call(newFilters, 'locationIds'))
			) {
				return updateFiltersProp(newFilters);
			}
			const columnKey = isLocationView ? 'locationIds' : 'fieldTechnicianEmails';
			return updateFiltersProp({
				...(newFilters || {}),
				[columnKey]: fetchedColumns.ids.join(','),
			});
		},
		[updateFiltersProp, calendarView, fetchedColumns.ids, isLocationView]
	);

	const resolvedTechnicianEmails = useMemo(
		() => orderedTechnicians.map((resource) => nullSafeGet(resourceKeyField, resource)),
		[orderedTechnicians, resourceKeyField]
	);

	const resetTechnicianScroll = useCallback(() => {
		setVisibleTechnicianOffset(0);
		setWeekTechnicianIndex(0);
		if (calendarScrollApiRef.current) {
			calendarScrollApiRef.current.scrollToColumn(0);
		}
	}, []);

	const handleTechnicianSelectionChange = useCallback(
		(nextOrderedEmails) => {
			setTechnicianSelection(nextOrderedEmails);
			resetTechnicianScroll();
		},
		[resetTechnicianScroll]
	);

	const handleRemoveTechnician = useCallback(
		(email) => {
			const removedIndex = orderedTechnicianEmails.indexOf(email);
			const nextEmails = orderedTechnicianEmails.filter((selectedEmail) => selectedEmail !== email);
			setTechnicianSelection(nextEmails);

			// Deliberately not resetTechnicianScroll(): closing one column should leave the calendar
			// where it is rather than send it back to the first technician. Only the viewport's own
			// column moves — dropping a column from the left of it shifts every later column one place,
			// so the offset follows; dropping one at or after it leaves the offset alone. Either way it
			// is clamped to the shorter roster's last page.
			const currentMaxOffset = Math.max(
				0,
				orderedTechnicianEmails.length - MAX_VISIBLE_TECHNICIAN_COLUMNS
			);
			const currentOffset = Math.min(visibleTechnicianOffset, currentMaxOffset);
			const removedBeforeViewport = removedIndex >= 0 && removedIndex < currentOffset;
			setVisibleTechnicianOffset(
				Math.min(
					removedBeforeViewport ? currentOffset - 1 : currentOffset,
					Math.max(0, nextEmails.length - MAX_VISIBLE_TECHNICIAN_COLUMNS)
				)
			);
			if (removedBeforeViewport && calendarScrollApiRef.current) {
				calendarScrollApiRef.current.scrollByColumns(-1);
			}
		},
		[orderedTechnicianEmails, visibleTechnicianOffset]
	);

	// `fetchAllFieldTechs` walks the roster a page at a time, so the whole run is tracked here rather
	// than through the slice's per-page fetching flag.
	const [loadingAllTechnicians, setLoadingAllTechnicians] = useState(true);
	const loadAllTechnicians = useCallback(() => {
		setLoadingAllTechnicians(true);
		return fetchAllFieldTechs()
			.catch(() => message.error('Failed to load technicians. Please try again.'))
			.finally(() => setLoadingAllTechnicians(false));
	}, [fetchAllFieldTechs]);

	// Regions with their locations nested underneath, for the picker's tree.
	const [locationTree, setLocationTree] = useState<any[]>([]);

	// The location view's equivalent of the roster fetch. Done here rather than inside the picker:
	// the columns default to every accessible location, so they have to be known before the picker is
	// ever opened. The flat list drives the columns; the hierarchy only shapes the picker.
	const loadAllLocations = useCallback(() => {
		setLoadingAllTechnicians(true);
		return Promise.all([
			fetchCalendarLocations(),
			fetchLocationTree().then((tree) => setLocationTree(tree || [])),
		])
			.catch(() => message.error('Failed to load locations. Please try again.'))
			.finally(() => setLoadingAllTechnicians(false));
	}, [fetchCalendarLocations, fetchLocationTree]);

	// "Mine" for someone with no calendar of their own: the roster has finished loading and still has
	// no column for them. Distinct from an emptied selection, which the Techs control can fix. The
	// copy stays clear of why they have no column, since that depends on assignment and role rules
	// this page does not model. Reads off orderedTechnicianEmails (not the raw technicianSelection
	// state) so it also covers field technicians, whose "own calendar only" scoping never touches
	// technicianSelection at all.
	const isViewingOwnCalendarOnly =
		Boolean(currentUserEmail) &&
		technicianSelection !== null &&
		technicianSelection.length === 1 &&
		technicianSelection[0] === currentUserEmail;
	// An empty array means the picker was actively cleared, which is a different thing from `null`
	// (nothing chosen yet, so every column shows). Applies to either view: clearing every technician
	// leaves a supplier just as stranded as clearing every location leaves a buyer.
	const clearedColumnSelection = technicianSelection !== null && technicianSelection.length === 0;

	const currentUserHasNoTechnicianRecord =
		!loadingAllTechnicians && isViewingOwnCalendarOnly && !techniciansByEmail[currentUserEmail];

	// AssignedFilters picks the highlighted tab by matching these values against the tab's own filter
	// set, and its "Mine" tab carries fieldTechnicianEmail. This page narrows by technician column and
	// deliberately keeps that filter out of the request (see handleAssignedFilterChange), which the
	// match reads as "no tab selected". Supply it here only so the control recognises its own choice;
	// what gets sent to the server is unaffected.
	const assignedFilterValue = useMemo(() => {
		const activeFilters = nullSafeGetOrElse('filters', workOrders, {});
		if (nullSafeGet('assigned', activeFilters) !== 'me') {
			return activeFilters;
		}
		return { ...activeFilters, fieldTechnicianEmail: currentUserEmail };
	}, [workOrders, currentUserEmail]);

	// These filters are not removed as per Keenan so we need to ensure that a saved url does not inject these and gets cleaned up
	const sanitizedSearch = useMemo(() => {
		const params = new URLSearchParams(nullSafeGetOrElse('search', location, ''));
		const removed = UNSUPPORTED_CALENDAR_QUERY_PARAMS.filter((param) => params.has(param));
		removed.forEach((param) => params.delete(param));
		return removed.length > 0 ? params.toString() : null;
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useMountEffect(() => {
		if (sanitizedSearch !== null) {
			props.history.replace(`${location.pathname}${sanitizedSearch ? `?${sanitizedSearch}` : ''}`);
		}
		if (isLocationView) {
			loadAllLocations();
		} else {
			loadAllTechnicians();
		}
	});

	useEffect(() => {
		if (loadingAllTechnicians) {
			return;
		}
		const columnFilter = computeVisibleColumnFilter();
		fetchData(
			{ ...location, search: sanitizedSearch === null ? location.search : sanitizedSearch },
			calendarDate,
			calendarView,
			columnFilter,
			false,
			calendarTimeZone
		);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [loadingAllTechnicians]);

	useEffect(() => {
		if (loadingAllTechnicians) {
			return;
		}

		if (calendarView === Views.WEEK) {
			const effectiveWeekIdx = Math.min(
				weekTechnicianIndex,
				Math.max(0, orderedTechnicians.length - 1)
			);
			const weekResource = orderedTechnicians[effectiveWeekIdx];
			const weekResourceKey = nullSafeGet(resourceKeyField, weekResource);
			updateFilters(
				weekResourceKey
					? isLocationView
						? { locationIds: weekResourceKey }
						: { fieldTechnicianEmails: weekResourceKey }
					: {}
			);
			return;
		}

		if (isFieldTechnicianUser) {
			updateFilters({});
			return;
		}

		const maxClamp = Math.max(0, orderedTechnicianEmails.length - MAX_VISIBLE_TECHNICIAN_COLUMNS);
		const clampedStart = Math.min(visibleTechnicianOffset, maxClamp);
		const fetchStart =
			clampedStart > 0 && clampedStart === maxClamp ? clampedStart - 1 : clampedStart;
		const fetchCount =
			orderedTechnicianEmails.length > MAX_VISIBLE_TECHNICIAN_COLUMNS
				? MAX_VISIBLE_TECHNICIAN_COLUMNS + 1
				: MAX_VISIBLE_TECHNICIAN_COLUMNS;
		const visibleKeys = orderedTechnicianEmails
			.slice(fetchStart, fetchStart + fetchCount)
			.filter(Boolean);

		if (visibleKeys.length === 0) {
			return;
		}

		const columnSetChanged = fetchedColumns.columnSetKey !== orderedTechEmailsKey;
		const currentColumnKeySet = new Set(orderedTechnicianEmails);
		const cachedIds = columnSetChanged
			? fetchedColumns.ids.filter((id) => currentColumnKeySet.has(id))
			: fetchedColumns.ids;
		const fetchedSet = new Set(cachedIds);

		if (!columnSetChanged && visibleKeys.every((id) => fetchedSet.has(id))) {
			return;
		}

		const firstUnfetchedVisibleIndex = visibleKeys.findIndex((id) => !fetchedSet.has(id));
		const firstMissingIndex = fetchStart + firstUnfetchedVisibleIndex;
		const newBatch = orderedTechnicianEmails
			.slice(firstMissingIndex, firstMissingIndex + DAY_VIEW_FETCH_BATCH_SIZE)
			.filter(Boolean);
		const newBatchOnly = newBatch.filter((id) => !fetchedSet.has(id));
		if (newBatchOnly.length === 0) {
			return;
		}
		const allFetchedIds = [...cachedIds, ...newBatchOnly];

		setFetchedColumns({ columnSetKey: orderedTechEmailsKey, ids: allFetchedIds });

		const columnKey = isLocationView ? 'locationIds' : 'fieldTechnicianEmails';
		fetchData(
			location,
			calendarDate,
			calendarView,
			{ [columnKey]: newBatchOnly.join(',') },
			fetchedColumns.ids.length > 0,
			calendarTimeZone
		);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [calendarView, visibleTechnicianOffset, orderedTechEmailsKey, weekTechnicianIndex]);

	const handleClearAndUpdateFilters = () => {
		const startDateFieldName = getStartDateFieldName(LAST_SERVICE_CALL_SCHEDULED_AT_FIELD);
		const endDateFieldName = getEndDateFieldName(LAST_SERVICE_CALL_SCHEDULED_AT_FIELD);

		const startDate = nullSafeGet(`filters.${startDateFieldName}`, workOrders);
		const endDate = nullSafeGet(`filters.${endDateFieldName}`, workOrders);

		const columnFilter = computeVisibleColumnFilter();
		setFetchedColumns({ columnSetKey: '', ids: [] });
		clearFilters({
			[startDateFieldName]: startDate,
			[endDateFieldName]: endDate,
			...columnFilter,
		});
	};

	const calendarTimeZone = useMemo(() => {
		if (isLocationView && orderedTechnicians.length === 1) {
			return nullSafeGet('timeZoneId', orderedTechnicians[0]) || moment.tz.guess();
		}
		return moment.tz.guess();
	}, [isLocationView, orderedTechnicians]);

	const calendarLocalizer = useMemo(() => {
		moment.tz.setDefault(calendarTimeZone);
		return momentLocalizer(moment);
	}, [calendarTimeZone]);

	// Helper function to update date filters based on view and date
	const updateDateFiltersForView = useCallback(
		(view, date) => {
			const startDateFieldName = getStartDateFieldName(LAST_SERVICE_CALL_SCHEDULED_AT_FIELD);
			const endDateFieldName = getEndDateFieldName(LAST_SERVICE_CALL_SCHEDULED_AT_FIELD);
			const { startDate, endDate } = calculateDateRangeForView(view, date, calendarTimeZone);

			if (startDate && endDate) {
				updateFilters({
					[startDateFieldName]: startDate,
					[endDateFieldName]: endDate,
				});
			}
		},
		[updateFilters, calendarTimeZone]
	);

	const handleEventDrop = async ({ event, start, end, resourceId }) => {
		const woStatus = event.status;
		const isReschedulable =
			TECH_SCHEDULED_STATUSES.includes(woStatus) || woStatus === WORK_ORDER_STATUSES.techEnRoute;
		const isSchedulable = SCHEDULE_TECH_STATUSES.includes(woStatus);

		if (!isReschedulable && !isSchedulable) {
			message.warning('This work order cannot be scheduled or rescheduled.');
			return;
		}

		// Sanitize the work order first
		const sanitizedWorkOrder = getSanitisedWorkOrder(event, true);

		// Fetch full work order if needed
		let fullWorkOrder = sanitizedWorkOrder;
		if (isAValidAndParitalWorkOrder(sanitizedWorkOrder)) {
			if (isLoadingFullWorkOrder) {
				return;
			}

			setIsLoadingFullWorkOrder(true);
			const hideLoading = message.loading('Loading work order details...', 0);
			try {
				const fetchedWorkOrder = await getFullWorkOrder(sanitizedWorkOrder.id);
				fullWorkOrder = getSanitisedWorkOrder(fetchedWorkOrder, true);
				hideLoading();
			} catch (error) {
				hideLoading();
				message.error('Failed to load work order details. Please try again.');
				setIsLoadingFullWorkOrder(false);
				return;
			} finally {
				setIsLoadingFullWorkOrder(false);
			}
		}

		const leadTechnicianEmail = getServiceCallLeadTechnicianEmail(fullWorkOrder);
		setDropTechnicianEmail(resourceId || scopedTechnicianEmail || leadTechnicianEmail || null);

		// Set the selected work order and new scheduled time
		setSelectedWorkOrder(fullWorkOrder);
		setNewScheduledTime(start);

		if (isReschedulable) {
			setRescheduleModalVisible(true);
		} else {
			setScheduleModalVisible(true);
		}
	};

	const handleRescheduleSubmit = () => {
		if (!rescheduleFormRef.current || !rescheduleFormRef.current.props) {
			return;
		}

		const form = rescheduleFormRef.current.props.form;
		if (!form) {
			return;
		}

		form.validateFields((err, values) => {
			if (err) {
				return;
			}
			const timeZone =
				values['serviceScheduledAtTimeZone'] ||
				nullSafeGet('location.timeZoneId', selectedWorkOrder);
			const lastServiceCall = nullSafeGetOrElse('lastServiceCall', selectedWorkOrder, {});
			const formData = {
				...lastServiceCall,
				...values,
				serviceScheduledAt: formatDateForLocationTimeZone(values.serviceScheduledAt, timeZone),
				workOrderId: nullSafeGet('id', selectedWorkOrder),
			};

			rescheduleServiceCall(formData)
				.then(() => {
					setRescheduleModalVisible(false);
					// Move calendar to the rescheduled time
					let newDate = calendarDate;
					if (values.serviceScheduledAt) {
						const scheduledMoment = moment(values.serviceScheduledAt);
						if (scheduledMoment.isValid()) {
							const scheduledDate = scheduledMoment.toDate();
							setScrollToTime(toCalendarZoneScrollTime(scheduledDate, calendarTimeZone));
							if (calendarView === Views.DAY) {
								setCalendarDate(scheduledDate);
								newDate = scheduledDate;
							}
						}
					} else if (newScheduledTime) {
						const scheduledDate = new Date(newScheduledTime);
						setScrollToTime(toCalendarZoneScrollTime(scheduledDate, calendarTimeZone));
						if (calendarView === Views.DAY) {
							setCalendarDate(scheduledDate);
							newDate = scheduledDate;
						}
					}
					setSelectedWorkOrder(null);
					setNewScheduledTime(null);
					setDropTechnicianEmail(null);
					fetchData(
						location,
						newDate,
						calendarView,
						getActiveColumnFilter(),
						false,
						calendarTimeZone
					);
					message.success('Service call rescheduled.');
				})
				.catch((error) => {
					console.error('Failed to reschedule service call:', error);
					message.error('Failed to reschedule service call. Please try again.');
				});
		});
	};

	const handleRescheduleCancel = () => {
		setRescheduleModalVisible(false);
		setSelectedWorkOrder(null);
		setNewScheduledTime(null);
		setDropTechnicianEmail(null);
	};

	const handleScheduleSubmit = () => {
		if (!scheduleFormRef.current || !scheduleFormRef.current.props) {
			return;
		}

		const form = scheduleFormRef.current.props.form;
		if (!form) {
			return;
		}

		form.validateFields((err, values) => {
			if (err) {
				return;
			}
			const timeZone =
				values['serviceScheduledAtTimeZone'] ||
				nullSafeGet('location.timeZoneId', selectedWorkOrder);
			const formData = {
				...values,
				serviceScheduledAt: formatDateForLocationTimeZone(values.serviceScheduledAt, timeZone),
				workOrderId: nullSafeGet('id', selectedWorkOrder),
				supplierFacilityId: nullSafeGetOrElse('supplierFacilityId', selectedWorkOrder, null),
			};

			scheduleServiceCall(formData)
				.then(() => {
					setScheduleModalVisible(false);
					// Move calendar to the scheduled time
					let newDate = calendarDate;
					if (values.serviceScheduledAt) {
						const scheduledMoment = moment(values.serviceScheduledAt);
						if (scheduledMoment.isValid()) {
							const scheduledDate = scheduledMoment.toDate();
							setScrollToTime(toCalendarZoneScrollTime(scheduledDate, calendarTimeZone));
							if (calendarView === Views.DAY) {
								setCalendarDate(scheduledDate);
								newDate = scheduledDate;
							}
						}
					} else if (newScheduledTime) {
						const scheduledDate = new Date(newScheduledTime);
						setScrollToTime(toCalendarZoneScrollTime(scheduledDate, calendarTimeZone));
						if (calendarView === Views.DAY) {
							setCalendarDate(scheduledDate);
							newDate = scheduledDate;
						}
					}
					setSelectedWorkOrder(null);
					setNewScheduledTime(null);
					setDropTechnicianEmail(null);
					fetchData(
						location,
						newDate,
						calendarView,
						getActiveColumnFilter(),
						false,
						calendarTimeZone
					);
					message.success('Service call scheduled.');
				})
				.catch((error) => {
					console.error('Failed to schedule service call:', error);
					message.error('Failed to schedule service call. Please try again.');
				});
		});
	};

	const handleScheduleCancel = () => {
		setScheduleModalVisible(false);
		setSelectedWorkOrder(null);
		setNewScheduledTime(null);
		setDropTechnicianEmail(null);
	};

	const draggableAccessor = (event) => {
		// Nothing is draggable on the location view: a drop would have to mean "move this work order
		// to that location", which is not what the gesture is for here. It stays read-only.
		if (isLocationView) {
			return false;
		}
		// Allow dragging for reschedulable WOs (TechScheduled, TechRescheduled, TechEnRoute)
		// and schedulable WOs (TechAssigned, ConfirmedByServiceProvider, etc.)
		const woStatus = event.status;
		return (
			TECH_SCHEDULED_STATUSES.includes(woStatus) ||
			woStatus === WORK_ORDER_STATUSES.techEnRoute ||
			SCHEDULE_TECH_STATUSES.includes(woStatus)
		);
	};

	const transformRecords = useMemo(() => {
		if (!data || data.length === 0) {
			return [];
		}
		const { viewStart, viewEnd } = getViewRange(calendarView, calendarDate);
		const viewStartMs = viewStart.valueOf();
		const viewEndMs = viewEnd.valueOf();

		return data.reduce((acc, workOrder) => {
			const lastServiceCall = nullSafeGet('lastServiceCall', workOrder);
			const serviceScheduledAt = nullSafeGet('serviceScheduledAt', lastServiceCall);

			if (!serviceScheduledAt) {
				return acc;
			}

			const checkInTime = nullSafeGet('checkInTime', lastServiceCall);
			const checkOutTime = nullSafeGet('checkOutTime', lastServiceCall);
			const displayStatus = nullSafeGet('displayStatus', workOrder);
			const status = nullSafeGet('status', workOrder);
			const dueDate = nullSafeGet('dueDate', workOrder);

			// Determine event status: Scheduled, PastDue, CheckedIn, OnHold, or Completed

			let eventStatus = 'Scheduled';

			if (
				displayStatus === WORK_ORDER_DISPLAY_STATUSES.hold ||
				status === WORK_ORDER_STATUSES.workIncompleteWithReason ||
				status === WORK_ORDER_STATUSES.workUnsatisfactory
			) {
				eventStatus = 'OnHold';
			} else if (displayStatus === WORK_ORDER_DISPLAY_STATUSES.complete) {
				eventStatus = 'Completed';
			} else if (displayStatus === WORK_ORDER_DISPLAY_STATUSES.pending) {
				eventStatus = 'Pending';
			} else if (checkInTime && !checkOutTime) {
				eventStatus = 'CheckedIn';
			} else if (displayStatus === 'Completed') {
				eventStatus = 'Completed';
			} else if (eventStatus === 'Scheduled' && dueDate && isDatePastDue(dueDate)) {
				eventStatus = 'PastDue';
			}

			const title = `${capitalize(nullSafeGetOrElse('title', workOrder, 'Scheduled'))}`;

			const startTime = checkInTime || serviceScheduledAt;
			const startMoment = moment(startTime).local();
			if (!startMoment.isValid()) {
				return acc;
			}
			const startDateObj = startMoment.toDate();

			// `end` drives both the card's height and react-big-calendar's overlap math, so it stays the
			// real end of the service call — never padded. A call too short to draw legibly is handled in
			// CSS (`.rbc-day-slot .rbc-event` has a pixel `min-height`), which grows the box without
			// telling the calendar the technician was busy longer than they were.
			let endDateObj;
			if (
				(eventStatus === 'CheckedIn' || eventStatus === 'Completed' || eventStatus === 'OnHold') &&
				checkOutTime
			) {
				const checkOutMoment = moment(checkOutTime).local();
				endDateObj = checkOutMoment.isValid()
					? checkOutMoment.toDate()
					: moment(startDateObj).add(1, 'hour').toDate();
			} else if (checkInTime && !checkOutTime) {
				endDateObj = moment().toDate();
			} else {
				endDateObj = moment(startDateObj).add(1, 'hour').toDate();
			}

			// The fetch reaches CALENDAR_LOOKBACK_DAYS before the view, so calls that finished before it
			// began come back too. Keep only the ones whose span actually touches the view.
			if (endDateObj.getTime() < viewStartMs || startDateObj.getTime() > viewEndMs) {
				return acc;
			}

			const leadTechnicianEmail = getServiceCallLeadTechnicianEmail(workOrder);
			const workOrderLocationId =
				nullSafeGet('locationId', workOrder) || nullSafeGet('location.id', workOrder);
			const showsStartTimeOnly = START_TIME_ONLY_EVENT_STATUSES.indexOf(eventStatus) >= 0;
			const displayEnd = showsStartTimeOnly || calendarView === Views.WEEK ? undefined : endDateObj;

			const event = {
				...workOrder,
				title,
				category: nullSafeGet('displayStatus', workOrder),
				eventStatus: eventStatus,
				technicianEmails: leadTechnicianEmail ? [leadTechnicianEmail] : [],
				locationIds: workOrderLocationId ? [workOrderLocationId] : [],
				displayEnd,
				start: startDateObj,
				end: endDateObj,
			};

			return acc.concat(event);
		}, []);
	}, [data, calendarView, calendarDate]);

	// Everything downstream — the column counts and the events themselves — reads the filtered set, so
	// a chip narrows the counts in the column headers too.
	const statusFilteredRecords = useMemo(
		() =>
			selectedEventStatuses.length > 0
				? transformRecords.filter((event) => selectedEventStatuses.indexOf(event.eventStatus) >= 0)
				: transformRecords,
		[transformRecords, selectedEventStatuses]
	);

	const workOrderCountsByEmail = useMemo(() => {
		const counts = {};
		statusFilteredRecords.forEach((event) => {
			nullSafeGetOrElse(resourceAccessorField, event, []).forEach((resourceKey) => {
				counts[resourceKey] = (counts[resourceKey] || 0) + 1;
			});
		});
		return counts;
	}, [statusFilteredRecords, resourceAccessorField]);

	const maxTechnicianOffset = useMemo(
		() => Math.max(0, orderedTechnicians.length - MAX_VISIBLE_TECHNICIAN_COLUMNS),
		[orderedTechnicians]
	);

	const resourceColumnCount = useMemo(() => {
		const count = orderedTechnicians.length;
		if (count === 0) {
			return 1;
		}
		return count <= MAX_VISIBLE_TECHNICIAN_COLUMNS ? count : 4.5;
	}, [orderedTechnicians.length]);

	const effectiveTechnicianOffset = Math.min(visibleTechnicianOffset, maxTechnicianOffset);
	const effectiveWeekTechnicianIndex = Math.min(
		weekTechnicianIndex,
		Math.max(0, orderedTechnicians.length - 1)
	);
	const weekTechnician = orderedTechnicians[effectiveWeekTechnicianIndex];

	const scopedTechnician =
		calendarView === Views.WEEK
			? weekTechnician
			: orderedTechnicians.length === 1
			? orderedTechnicians[0]
			: undefined;
	// Left undefined on the location view: the drawer that consumes it is hidden there, and the
	// scoped record is a location, not a technician.
	const scopedTechnicianEmail = isLocationView
		? undefined
		: isFieldTechnicianUser
		? currentUserEmail
		: nullSafeGet('email', scopedTechnician);
	const scopedTechnicianLabel =
		!isLocationView && scopedTechnician
			? isFieldTechnicianUser
				? getFieldTechDisplayName(currentUser)
				: scopedTechnician
				? getFieldTechDisplayName(scopedTechnician)
				: ''
			: '';

	const technicianResources = useMemo(
		() =>
			orderedTechnicians.map((resource) => ({
				...resource,
				workOrderCount: workOrderCountsByEmail[nullSafeGet(resourceKeyField, resource)] || 0,
			})),
		[orderedTechnicians, workOrderCountsByEmail, resourceKeyField]
	);

	// Week view shows one technician at a time; day view puts every WO in its own technician column.
	const visibleEvents = useMemo(() => {
		if (calendarView !== Views.WEEK) {
			return statusFilteredRecords;
		}
		const weekResourceKey = nullSafeGet(resourceKeyField, weekTechnician);
		if (!weekResourceKey) {
			return [];
		}
		return statusFilteredRecords.filter(
			(event) => nullSafeGetOrElse(resourceAccessorField, event, []).indexOf(weekResourceKey) >= 0
		);
	}, [
		statusFilteredRecords,
		calendarView,
		weekTechnician,
		resourceKeyField,
		resourceAccessorField,
	]);

	const scrollTechnicianColumns = useCallback((delta) => {
		if (calendarScrollApiRef.current) {
			calendarScrollApiRef.current.scrollByColumns(delta);
		}
	}, []);

	const handlePreviousTechnicianPage = useCallback(
		() => scrollTechnicianColumns(-1),
		[scrollTechnicianColumns]
	);

	const handleNextTechnicianPage = useCallback(
		() => scrollTechnicianColumns(1),
		[scrollTechnicianColumns]
	);

	const handlePreviousWeekTechnician = useCallback(
		() => setWeekTechnicianIndex((index) => Math.max(0, index - 1)),
		[]
	);

	const handleNextWeekTechnician = useCallback(
		() => setWeekTechnicianIndex((index) => Math.min(index + 1, orderedTechnicians.length - 1)),
		[orderedTechnicians]
	);

	const handleCalendarNavigate = useCallback(
		(date) => {
			setCalendarDate(date);
			updateDateFiltersForView(calendarView, date);
		},
		[calendarView, updateDateFiltersForView]
	);

	const handleCalendarViewChange = useCallback(
		(view) => {
			setCalendarView(view);
			if (view !== Views.DAY) {
				setFetchedColumns({ columnSetKey: '', ids: [] });
				const startDateFieldName = getStartDateFieldName(LAST_SERVICE_CALL_SCHEDULED_AT_FIELD);
				const endDateFieldName = getEndDateFieldName(LAST_SERVICE_CALL_SCHEDULED_AT_FIELD);
				const { startDate, endDate } = calculateDateRangeForView(
					view,
					calendarDate,
					calendarTimeZone
				);
				updateFilters({
					[startDateFieldName]: startDate,
					[endDateFieldName]: endDate,
					fieldTechnicianEmails: undefined,
					locationIds: undefined,
				});
			} else {
				updateDateFiltersForView(view, calendarDate);
			}
		},
		[updateFilters, updateDateFiltersForView, calendarDate, calendarTimeZone]
	);

	const isWeekView = calendarView === Views.WEEK;

	useMountEffect(() => {
		return () => {
			moment.tz.setDefault();
		};
	});

	const handleToolbarNavigate = useCallback(
		(action) => {
			if (action === 'TODAY') {
				handleCalendarNavigate(new Date());
				return;
			}
			const unit = isWeekView ? 'week' : 'day';
			const shifted =
				action === 'PREV'
					? moment(calendarDate).subtract(1, unit)
					: moment(calendarDate).add(1, unit);
			handleCalendarNavigate(shifted.toDate());
		},
		[calendarDate, isWeekView, handleCalendarNavigate]
	);

	const toggleEventStatus = useCallback(
		(statusKey) =>
			setSelectedEventStatuses((current) =>
				current.indexOf(statusKey) >= 0
					? current.filter((key) => key !== statusKey)
					: current.concat(statusKey)
			),
		[]
	);

	const openFullscreen = () => setIsFullscreen(true);
	const closeFullscreen = () => setIsFullscreen(false);

	// Popups default to a document.body portal, which sits outside the fixed overlay's stacking and
	// event context — dropdown and popover clicks there never register. Scope them to the overlay
	// while it is open. Same fix, and the same reason, as LocationsMapView's fullscreen mode.
	const popupContainer = useMemo(
		() =>
			isFullscreen
				? (trigger: HTMLElement) => {
						if (trigger.closest('.ant-modal-wrap, .ant-drawer-wrap')) {
							return document.body;
						}
						return overlayRef.current || document.body;
				  }
				: undefined,
		[isFullscreen]
	);

	const woCountsByDay = useMemo(() => {
		const { viewStart, viewEnd } = getViewRange(calendarView, calendarDate);
		return visibleEvents.reduce((counts, event) => {
			const startDay = moment(event.start).startOf('day');
			const endDay = moment(event.end).subtract(1, 'millisecond').startOf('day');
			const clampedStart = moment.max(startDay, viewStart.clone().startOf('day'));
			const clampedEnd = moment.min(endDay, viewEnd.clone().startOf('day'));
			for (let day = clampedStart.clone(); !day.isAfter(clampedEnd); day.add(1, 'day')) {
				const dayKey = day.format('YYYY-MM-DD');
				counts[dayKey] = (counts[dayKey] || 0) + 1;
			}
			return counts;
		}, {} as Record<string, number>);
	}, [visibleEvents, calendarView, calendarDate]);

	const WeekDayHeader = useMemo(
		() =>
			({ date }: { date: Date }) => {
				const dayKey = moment(date).format('YYYY-MM-DD');
				const count = woCountsByDay[dayKey] || 0;
				return (
					<div className="flex flex-col items-start px-2 py-2" style={{ height: 86 }}>
						<span className="footnoteregular uppercase text-character-secondary">
							{moment(date).format('ddd')}
						</span>
						<span className="h5medium text-character-primary">{moment(date).format('DD')}</span>
						<span className="footnoteregular text-character-secondary">
							{count} WO{count !== 1 ? 's' : ''}
						</span>
					</div>
				);
			},
		[woCountsByDay]
	);

	const calendarComponents = useMemo(
		() => ({
			...CALENDAR_COMPONENTS,
			event: (eventProps) => (
				<AppointmentCard
					{...eventProps}
					isLocationView={isLocationView}
					calendarTimeZone={calendarTimeZone}
				/>
			),
			...(isWeekView ? { header: WeekDayHeader } : {}),
		}),
		[isLocationView, isWeekView, WeekDayHeader, calendarTimeZone]
	);

	const renderTechnicianColumnHeader = useCallback(
		(resource) =>
			isLocationView ? (
				<LocationColumnHeader location={resource} onRemove={handleRemoveTechnician} />
			) : (
				<TechnicianColumnHeader
					technician={resource}
					onRemove={isFieldTechnicianUser ? undefined : handleRemoveTechnician}
				/>
			),
		[handleRemoveTechnician, isLocationView, isFieldTechnicianUser]
	);

	const technicianNavValue = useMemo(
		() =>
			isWeekView
				? {
						technician: weekTechnician,
						identity:
							isLocationView && weekTechnician ? (
								<LocationIdentity location={weekTechnician} widthClassName="w-full" />
							) : undefined,
						onPrevious: handlePreviousWeekTechnician,
						onNext: handleNextWeekTechnician,
						previousDisabled: effectiveWeekTechnicianIndex <= 0,
						nextDisabled: effectiveWeekTechnicianIndex >= orderedTechnicians.length - 1,
						hideArrows: isFieldTechnicianUser,
				  }
				: {
						technician: undefined,
						label: isLocationView ? 'Locations' : 'Techs',
						onPrevious: handlePreviousTechnicianPage,
						onNext: handleNextTechnicianPage,
						previousDisabled: effectiveTechnicianOffset <= 0,
						nextDisabled: effectiveTechnicianOffset >= maxTechnicianOffset,
						hideArrows: isFieldTechnicianUser,
				  },
		[
			isWeekView,
			isLocationView,
			weekTechnician,
			handlePreviousWeekTechnician,
			handlePreviousTechnicianPage,
			handleNextWeekTechnician,
			handleNextTechnicianPage,
			effectiveWeekTechnicianIndex,
			effectiveTechnicianOffset,
			orderedTechnicians.length,
			maxTechnicianOffset,
			isFieldTechnicianUser,
		]
	);

	const assignedFilterItems = useMemo(() => {
		const assignedConfig = ASSIGNED_FILTERS(currentUser);
		return isInternalTeam
			? assignedConfig.items.filter(
					(item) => item.selectVal !== 'team' && item.selectVal !== 'serviceprovider'
			  )
			: assignedConfig.items;
	}, [currentUser, isInternalTeam]);

	const handleAssignedFilterChange = useCallback(
		(filters) => {
			if (filters && filters.assigned === 'me') {
				const currentUserEmail = nullSafeGet('email', currentUser);
				if (currentUserEmail) {
					setTechnicianSelection([currentUserEmail]);
					resetTechnicianScroll();
				}
				updateFilters({ ...filters, fieldTechnicianEmail: undefined });
				return;
			}
			setTechnicianSelection(null);
			updateFilters(filters);
		},
		[currentUser, updateFilters, resetTechnicianScroll]
	);

	const advancedFiltersConfig = useMemo(
		() =>
			isLocationView
				? BUYER_WO_FILTERS_ORDER
				: isInternalTeam
				? INTERNAL_SERVICE_TEAM_WO_FILTERS_ORDER
				: isSupplierPayingCustomer(currentUser)
				? PAYING_SUPPLIER_WO_FILTER_ORDER
				: THIRD_PARTY_SUPPLIER_WO_FILTERS_ORDER,
		[currentUser, isInternalTeam, isLocationView]
	);

	// Brands is the buyer-side filter set. BUYER_WO_FILTERS_ORDER names it, so without this the order
	// list looks it up in a defaultConfig that never held it and the filter is silently dropped.
	const BUYER_FILTER_CONFIGS = useBuyerFilterConfiguration({
		updateFilters,
		brands,
		fetchBrands,
		fetchMultipleBrands,
	});
	const SUPPLIER_FILTER_CONFIG = useSupplierFilterConfiguration({
		fieldTechs,
		updateFilters,
		fetchFieldTechs,
		fetchMultipleFieldTechs,
		spendCategories,
		fetchSpendCategories,
		fetchMultipleSpendCategories,
		contractorPrivateNetworks,
		fetchContractors,
		currentUser,
		contractorClients,
		fetchContractorClients,
		fetchMultipleContractorClients,
		contractorLocations,
		fetchContractorLocations,
		fetchMultipleContractorLocations,
	});
	const COMMON_FILTER_CONFIGS = useCommonFilterConfiguration({
		locations,
		fetchLocations,
		areas,
		fetchAreasDistinct,
		workOrderPriorities,
		fetchWorkOrderPriorities,
		assets,
		fetchAssets,
		fetchMultipleAssets,
		assetTypes,
		fetchAssetTypes,
		fetchMultipleAssetTypes,
		planned_maintenance_schedules,
		fetchPMSchedule,
		fetchMultiplePMSchedule,
		problemTypes,
		fetchProblemTypes,
		currentUser,
		supplierFacilities,
		fetchSupplierFacilitiesInPrivateNetwork,
		resolutionTypes,
		fetchResolutionTypes,
		fetchMultipleResolutionTypes,
		staleDays,
		updateFilters,
		users,
		fetchUsers,
		fetchMultipleUsers,
	});

	const FILTER_CONFIG = useMemo(() => {
		// SUPPLIER_FILTER_CONFIG is clients/contractors/technicians — supplier-only concepts;
		// BUYER_FILTER_CONFIGS is brands. Each role gets the common set plus its own.
		const defaultConfig: any[] = isLocationView
			? [...COMMON_FILTER_CONFIGS, ...BUYER_FILTER_CONFIGS]
			: [...COMMON_FILTER_CONFIGS, ...SUPPLIER_FILTER_CONFIG];

		const advancedFilterConfig =
			advancedFiltersConfig && advancedFiltersConfig.length > 0
				? advancedFiltersConfig.map((filter) => defaultConfig.find((_) => _.fieldName === filter))
				: defaultConfig;
		return advancedFilterConfig.filter(
			(_) =>
				!!_ &&
				_.fieldName !== FILTER_CONFIG_NAMES.LAST_SERVICE_CALL_SCHEDULED_AT &&
				_.fieldName !== FILTER_CONFIG_NAMES.TECHNICIAN &&
				_.fieldName !== FILTER_CONFIG_NAMES.NOTES_STATUS &&
				!(isLocationView && _.fieldName === FILTER_CONFIG_NAMES.LOCATION)
		);
	}, [
		advancedFiltersConfig,
		COMMON_FILTER_CONFIGS,
		SUPPLIER_FILTER_CONFIG,
		BUYER_FILTER_CONFIGS,
		isLocationView,
	]);

	const calendarPreAppliedFilters = useMemo(() => {
		const activeFilters = nullSafeGetOrElse('filters', workOrders, {});
		const filterConfigKeys = new Set(
			FILTER_CONFIG.map((f: any) => f && f.fieldName).filter(Boolean)
		);
		return Object.keys(activeFilters).reduce((acc: any, key) => {
			if (!filterConfigKeys.has(key)) {
				acc[key] = activeFilters[key];
			}
			return acc;
		}, {});
	}, [workOrders, FILTER_CONFIG]);

	const myTimeZone = useMemo(() => moment.tz.guess(), []);

	const customHeader = useCallback(
		({ counts, applySorting, sorters, pagination, applyFilters, filters }) => (
			<>
				<div className="flex flex-row items-start justify-between px-4 pt-4">
					<div className="flex flex-col items-start justify-start gap-y-2">
						<div className="flex flex-col flex-wrap items-start justify-start gap-3">
							<div className="h5medium text-character-primary">
								Schedule Work Orders {pagination.total ? `(${pagination.total})` : null}
							</div>
							{scopedTechnicianEmail ? (
								<div className="bodyregular text-grey-8">
									Showing work orders visible to{' '}
									<span className="font-medium">{scopedTechnicianLabel}</span>
								</div>
							) : null}
							<div className="flex flex-row flex-wrap items-center justify-start gap-2">
								<OWSearchInput
									key="schedule-work-orders-search"
									placeholder="Search WOs"
									onChange={(value) => applyFilters({ search: value })}
									size="small"
									style={{ width: 150 }}
								/>
								<Sorter
									size="small"
									items={WORK_ORDER_SORTERS}
									value={sorters}
									onChange={applySorting}
								/>
							</div>
						</div>
					</div>
					<Button
						type="text"
						icon={<CloseOutlined />}
						onClick={() => setShowScheduleWOs((prev) => !prev)}
					/>
				</div>
				<Divider style={{ margin: '16px 0 0 0' }} />
			</>
		),
		[scopedTechnicianEmail, scopedTechnicianLabel]
	);

	useMountEffect(() => {
		const initialScrollTime = new Date();
		initialScrollTime.setHours(4, 0, 0, 0);
		setScrollToTime(initialScrollTime);
	});

	const lastSyncedTechEmailRef = useRef<string | undefined>();

	useEffect(() => {
		if (!showScheduleWOs) {
			return;
		}

		if (!syncScheduleTechnicianFilter) {
			return;
		}

		const nextEmail = scopedTechnicianEmail || undefined;

		if (lastSyncedTechEmailRef.current === nextEmail) {
			return;
		}

		lastSyncedTechEmailRef.current = nextEmail;

		syncScheduleTechnicianFilter({
			fieldTechnicianVisibilityEmail: nextEmail,
		});
	}, [showScheduleWOs, scopedTechnicianEmail, syncScheduleTechnicianFilter]);

	// Memoize CustomWorkOrderRowDisplayProps to prevent unnecessary re-renders
	const customWorkOrderRowDisplayProps = useMemo(
		() => ({
			onRefreshTable: (scheduledTime) => {
				if (scheduledTime) {
					const scheduledMoment = moment(scheduledTime);
					if (scheduledMoment.isValid()) {
						const scheduledDate = scheduledMoment.toDate();
						setScrollToTime(toCalendarZoneScrollTime(scheduledDate, calendarTimeZone));
						if (calendarView === Views.DAY) {
							setCalendarDate(scheduledDate);
							updateDateFiltersForView(calendarView, scheduledDate);
						} else {
							fetchData(
								location,
								calendarDate,
								calendarView,
								getActiveColumnFilter(),
								false,
								calendarTimeZone
							);
						}
					}
				} else {
					// If no scheduled time, just refresh the data
					fetchData(
						location,
						calendarDate,
						calendarView,
						getActiveColumnFilter(),
						false,
						calendarTimeZone
					);
				}
			},
			leadTechnicianEmail: scopedTechnicianEmail,
			serviceScheduledAt: calendarView === Views.DAY ? moment() : null,
		}),
		[
			calendarView,
			calendarDate,
			updateDateFiltersForView,
			fetchData,
			location,
			scopedTechnicianEmail,
			calendarTimeZone,
			getActiveColumnFilter,
		]
	);

	// Memoize renderEmptyState callback
	const renderEmptyState = useCallback(() => <EmptyState headline="No open work orders" />, []);

	const scheduleWorkOrdersPreAppliedFilters = useMemo(() => {
		const baseFilters = {
			unscheduledOrPastSchedule: true,
			statuses: isInternalTeam
				? 'Unassigned,AssignedToInternalTech,TechCancelled,TechAssigned,TechScheduled,TechRescheduled,WorkIncompleteWithReason'
				: 'PendingConfirmationByServiceProvider,TechCancelled,PendingConfirmationByServiceProvider,TechAssigned,TechScheduled,TechRescheduled,WorkIncompleteWithReason',
		};
		if (scopedTechnicianEmail) {
			return {
				...baseFilters,
				fieldTechnicianVisibilityEmail: scopedTechnicianEmail,
			};
		}
		return baseFilters;
	}, [scopedTechnicianEmail, isInternalTeam]);

	return (
		<ConfigProvider getPopupContainer={popupContainer}>
			<div
				ref={overlayRef}
				className={cn(
					isFullscreen && 'fixed inset-0 z-[1000] flex flex-col overflow-auto bg-white'
				)}
			>
				{isFullscreen ? (
					<div className="flex shrink-0 items-center gap-5 p-4">
						<Button type="default" icon={<ArrowLeftOutlined />} onClick={closeFullscreen}>
							Back
						</Button>
						<div className="h3regular mb-0 text-character-primary">
							{isLocationView ? 'Store Calendar: Locations' : 'Service Calendar: Technicians'}
						</div>
					</div>
				) : null}
				<Content className="supplierWorkOrdersIndexPage relative" style={{ padding: '0 0.5em' }}>
					{showScheduleWOs || isLocationView ? null : (
						<div
							className=" absolute left-[-7px]  top-1/2 z-50 mx-0 flex -translate-y-1/2 transform cursor-pointer flex-row items-center justify-center gap-1  bg-white px-1  py-3 font-medium tracking-wide text-supplier"
							style={{
								writingMode: 'sideways-lr',
								textOrientation: 'mixed',
								border: '1px solid var(--Grey-5, #D9D9D9)',
								position: 'absolute',
								transform: 'translateY(-50%)',
								borderRadius: '0 10px 10px 0px',
							}}
							onClick={() => setShowScheduleWOs(!showScheduleWOs)}
						>
							<span>Schedule Work Orders</span>
							<CaretDownFilled style={{ transform: 'rotate(270deg)' }} />
						</div>
					)}
					<Row key={2} style={{ margin: '1 -8px' }} gutter={[12, 12]}>
						<Col span={24} className={cn({ 'bg-grey-4 !px-4': isFullscreen })}>
							<SubnavBar
								left={
									<div className="my-2 flex flex-row flex-wrap items-center gap-3">
										<Filters
											filterConfig={FILTER_CONFIG}
											currentUser={currentUser}
											applyFilters={updateFilters}
											filters={nullSafeGetOrElse(`filters`, workOrders, {})}
											clearFilters={handleClearAndUpdateFilters}
											targetCollectionName={WORK_ORDERS_CALENDAR_TARGET_COLLECTION}
											userType={userType}
											preAppliedFilters={calendarPreAppliedFilters}
											sorterItems={[]}
											filterPlaceHolder="Search WOs"
										/>

										<AssignedFilters
											items={assignedFilterItems}
											currentUser={currentUser}
											userType={userType}
											value={assignedFilterValue}
											onChange={handleAssignedFilterChange}
											selector={ASSIGNED_FILTERS(currentUser).selector}
										/>
										<SubcontractedFilters
											items={SUBCONTRACTED_FILTERS(currentUser).items}
											currentUser={currentUser}
											userType={userType}
											value={nullSafeGetOrElse(`filters`, workOrders, {})}
											onChange={updateFilters}
											selector={SUBCONTRACTED_FILTERS(currentUser).selector}
										/>
										<div className="grow" />
										{!isFullscreen && (
											<Button
												icon={<FullscreenOutlined />}
												title="Expand calendar"
												aria-label="Expand calendar to full screen"
												onClick={isFullscreen ? undefined : openFullscreen}
											/>
										)}
									</div>
								}
								right={null}
							/>
						</Col>
					</Row>
					<SelectedFilters
						updateFilters={updateFilters}
						filterValues={nullSafeGetOrElse(`filters`, workOrders, {})}
						filterConfig={FILTER_CONFIG}
						containerClassName="mt-3"
					/>

					<Row key={3} gutter={16} align="stretch" className="relative">
						{showScheduleWOs ? (
							<Col span={8} className="animate-slideInFromLeft">
								<Card
									style={{
										minHeight: 560,
										maxHeight: '100vh',
										padding: 0,
										height: '100%',
										display: 'flex',
										flexDirection: 'column',
									}}
									bodyStyle={{
										padding: 0,
										flex: 1,
										display: 'flex',
										flexDirection: 'column',
										overflow: 'scroll',
									}}
								>
									<WorkOrderTable
										ignoreRefreshCounts={true}
										handleQueryParams={false}
										preAppliedFilters={scheduleWorkOrdersPreAppliedFilters}
										CustomHeader={customHeader}
										CustomWorkOrderRowDisplay={ServiceCalendarWorkOrderRow}
										CustomWorkOrderRowDisplayProps={customWorkOrderRowDisplayProps}
										renderEmptyState={renderEmptyState}
										targetCollectionName={WORK_ORDERS_SCHEDULE_TARGET_COLLECTION}
									/>
								</Card>
							</Col>
						) : null}

						<Col span={showScheduleWOs ? 16 : 24} className={cn('!p-0', { 'mt-2': !isFullscreen })}>
							<Card
								style={{
									minHeight: 560,
									maxHeight: '100vh',
									height: '100%',
									display: 'flex',
									flexDirection: 'column',
									position: 'relative',
									marginLeft: 0,
								}}
								bodyStyle={{
									padding: 0,
									flex: 1,
									display: 'flex',
									flexDirection: 'column',
									overflow: 'hidden',
									position: 'relative',
								}}
							>
								{fetching && (
									<div className="absolute inset-0 z-10 flex items-center justify-center bg-white bg-opacity-80">
										<Spin size="large" />
									</div>
								)}
								<CustomCalendarToolbar
									date={calendarDate}
									view={calendarView}
									views={CALENDAR_TOOLBAR_VIEWS}
									onNavigate={handleToolbarNavigate}
									onView={handleCalendarViewChange}
									activeStatusKeys={selectedEventStatuses}
									onStatusToggle={toggleEventStatus}
									leftExtra={
										isLocationView ? (
											<LocationFilterPopover
												// The resolved ids, not technicianSelection: with nothing picked yet the
												// calendar is already showing every location, so every box has to read as
												// ticked. Same prop the technician popover gets.
												selectedLocationIds={resolvedTechnicianEmails}
												knownLocations={locationPickerOptions}
												locationTree={locationTree}
												defaultCount={locationPickerOptions.length}
												usingDefaultSelection={technicianSelection === null}
												fetching={loadingAllTechnicians}
												loading={loadingAllTechnicians}
												onChange={handleTechnicianSelectionChange}
											/>
										) : isFieldTechnicianUser ? null : (
											<TechnicianFilterPopover
												technicians={technicians}
												technicianCount={technicianCount}
												selectedEmails={resolvedTechnicianEmails}
												usingDefaultSelection={technicianSelection === null}
												onChange={handleTechnicianSelectionChange}
												fetching={loadingAllTechnicians}
												loading={loadingAllTechnicians}
											/>
										)
									}
									compact={showScheduleWOs}
									timeZone={calendarTimeZone}
								/>
								<TechnicianNavContext.Provider value={technicianNavValue}>
									<div className="relative flex min-h-0 flex-1 flex-col overflow-hidden">
										{/* Week view is normally excluded: it scopes to one column at a time, and an empty
								    grid there still reads as "this week, nothing on it". A cleared selection is
								    different — there is no column to scope to and no way back except the picker,
								    so it needs the message in both views. */}
										{(!isWeekView || clearedColumnSelection) &&
										!loadingAllTechnicians &&
										orderedTechnicians.length === 0 ? (
											<EmptyState
												height={320}
												headline={
													isLocationView
														? 'No location columns'
														: currentUserHasNoTechnicianRecord
														? 'Nothing assigned to you'
														: 'No technician columns'
												}
												body={
													<div className="max-w-[488px] text-center">
														{isLocationView
															? clearedColumnSelection
																? 'Open Locations to pick which ones appear on the calendar.'
																: 'No work orders are scheduled in this range. Change the date to see other calendars.'
															: currentUserHasNoTechnicianRecord
															? isFieldTechnicianUser
																? 'You do not have any work orders assigned to you.'
																: 'You do not have any work orders assigned to you. Choose All to see the team.'
															: 'Open Techs to pick who appears on the calendar.'}
													</div>
												}
											/>
										) : (
											<EventCalendar
												toolbar={false}
												localizer={calendarLocalizer}
												events={visibleEvents}
												date={calendarDate}
												view={calendarView}
												defaultView={Views.DAY}
												scrollToTime={scrollToTime}
												onNavigate={handleCalendarNavigate}
												onView={handleCalendarViewChange}
												views={{ week: true, day: true }}
												components={calendarComponents}
												resources={calendarView === Views.DAY ? technicianResources : undefined}
												scrollApiRef={calendarScrollApiRef}
												onResourceScrollIndexChange={setVisibleTechnicianOffset}
												resourceIdAccessor={resourceKeyField}
												resourceTitleAccessor={renderTechnicianColumnHeader}
												resourceAccessor={resourceAccessorField}
												dayLayoutAlgorithm={stackingLayout}
												resizable={false}
												onEventDrop={handleEventDrop}
												draggableAccessor={draggableAccessor}
												resourceColumnCount={
													calendarView === Views.DAY ? resourceColumnCount : undefined
												}
												step={15}
												timeslots={4}
											/>
										)}
										<CalendarRightNav />
									</div>
								</TechnicianNavContext.Provider>
							</Card>
						</Col>
					</Row>
					{rescheduleModalVisible && selectedWorkOrder && (
						<ScheduleServiceCallModalForm
							wrappedComponentRef={(ref) => {
								rescheduleFormRef.current = ref;
							}}
							formData={{
								...nullSafeGetOrElse('lastServiceCall', selectedWorkOrder, {}),
								workOrder: selectedWorkOrder,
								leadTechnicianEmail:
									dropTechnicianEmail ||
									nullSafeGet('lastServiceCall.leadTechnicianEmail', selectedWorkOrder),
								serviceScheduledAt: newScheduledTime
									? moment(newScheduledTime)
									: nullSafeGet(
											'serviceScheduledAt',
											nullSafeGetOrElse('lastServiceCall', selectedWorkOrder, {})
									  )
									? moment(
											nullSafeGet(
												'serviceScheduledAt',
												nullSafeGetOrElse('lastServiceCall', selectedWorkOrder, {})
											)
									  )
									: undefined,
							}}
							isReschedule={true}
							visible={rescheduleModalVisible}
							onCancel={handleRescheduleCancel}
							onSubmit={handleRescheduleSubmit}
							initialTimeZone={myTimeZone}
						/>
					)}
					{scheduleModalVisible && selectedWorkOrder && (
						<ScheduleServiceCallModalForm
							wrappedComponentRef={(ref) => {
								scheduleFormRef.current = ref;
							}}
							formData={{
								workOrder: selectedWorkOrder,
								workOrderId: selectedWorkOrder.id,
								leadTechnicianEmail: dropTechnicianEmail || undefined,
								supplierFacilityId: nullSafeGetOrElse(
									'supplierFacilityId',
									selectedWorkOrder,
									null
								),
								serviceScheduledAt: newScheduledTime ? moment(newScheduledTime) : undefined,
							}}
							visible={scheduleModalVisible}
							onCancel={handleScheduleCancel}
							onSubmit={handleScheduleSubmit}
							initialTimeZone={myTimeZone}
						/>
					)}
				</Content>
			</div>
		</ConfigProvider>
	);
};

const mapStateToProps = (state, ownProps) => ({
	history: ownProps.history,
	location: ownProps.location,
	workOrders: state.work_orders[WORK_ORDERS_CALENDAR_TARGET_COLLECTION] || {},
	data: selectCalendarWorkOrders(state),
	fetching: state.work_orders[WORK_ORDERS_CALENDAR_TARGET_COLLECTION]
		? state.work_orders[WORK_ORDERS_CALENDAR_TARGET_COLLECTION].fetching
		: false,
	locations: state.locations,
	calendarLocationOptions: selectCalendarLocationOptions(state),
	workOrderPriorities: state.work_order_priorities,
	fieldTechs: state.field_techs,
	technicians: selectCalendarTechnicians(state),
	technicianCount: nullSafeGetOrElse(
		`${SERVICE_CALENDAR_TECHNICIANS_TARGET_COLLECTION}.count`,
		state.field_techs,
		0
	),
	assetTypes: state.asset_types,
	assets: state.assets,
	contractorPrivateNetworks: state.contractor_private_networks,
	spendCategories: state.spend_categories,
	problemTypes: state.problem_types,
	regions: state.regions,
	areas: state.areas,
	resolutionTypes: state.resolution_types,
	supplierFacilities: state.supplier_facilities,
	planned_maintenance_schedules: state.planned_maintenance_schedules,
	contractorClients: state.contractor_clients,
	contractorLocations: state.contractor_locations,
	users: state.all_contacts,
	brands: state.brands,
	companyConfig: state.company_config,
});

const mapDispatchToProps = (dispatch, ownProps) => {
	const startDateFieldName = getStartDateFieldName(LAST_SERVICE_CALL_SCHEDULED_AT_FIELD);
	const endDateFieldName = getEndDateFieldName(LAST_SERVICE_CALL_SCHEDULED_AT_FIELD);

	const currentUserEmail = nullSafeGet('email', ownProps.currentUser);
	const fieldTechnicianEmail =
		isFieldTech(ownProps.currentUser) && currentUserEmail ? currentUserEmail : undefined;
	const addFieldTechnicianEmailToFilters = (filters) =>
		fieldTechnicianEmail ? { ...(filters || {}), fieldTechnicianEmail } : filters;

	const urlSafeHistory = createUrlSanitizingHistory(ownProps.history);

	return {
		fetchData: (
			location,
			date,
			view,
			columnFilter = {},
			addToTargetCollection = false,
			calendarTimeZone = moment.tz.guess()
		) => {
			// Use provided date/view, or fall back to current day/DAY view
			const selectedDate = date || new Date();
			const selectedView = view || Views.DAY;
			const { startDate, endDate } = calculateDateRangeForView(
				selectedView,
				selectedDate,
				calendarTimeZone
			);

			return dispatch(
				fetchWorkOrders(ownProps.userType)(
					true, // handleQueryParams
					urlSafeHistory,
					location,
					WORK_ORDERS_CALENDAR_TARGET_COLLECTION,
					{
						[startDateFieldName]: startDate,
						[endDateFieldName]: endDate,
						[getWorkOrderArchivalKey(ownProps.currentUser)]: false,
						fieldTechnicianEmail,
						...columnFilter,
					},
					{ current: 1, pageSize: CALENDAR_PAGE_SIZE },
					ownProps.initialSorting,
					ownProps.initialFilters,
					false,
					addToTargetCollection
				)
			);
		},
		updateFilters: (filters) =>
			dispatch(
				updateFiltersWorkOrders(ownProps.userType)(
					true, // handleQueryParams
					urlSafeHistory,
					WORK_ORDERS_CALENDAR_TARGET_COLLECTION,
					addFieldTechnicianEmailToFilters(filters),
					false // ignoreRefreshCounts
				)
			),
		clearFilters: (preserveFilters) =>
			dispatch(
				clearFiltersWorkOrders(ownProps.userType)(
					true, // handleQueryParams
					urlSafeHistory,
					WORK_ORDERS_CALENDAR_TARGET_COLLECTION,
					addFieldTechnicianEmailToFilters(preserveFilters),
					false // ignoreRefreshCounts
				)
			),
		fetchMultipleWorkOrderPriorities: (ids, targetCollectionName) =>
			dispatch(
				ownProps.userType === ROLE_TYPES.SUPPLIER
					? workOrderPrioritiesRestCrudThunksForSupplier.readMultiple(ids, targetCollectionName)
					: workOrderPrioritiesRestCrudThunksForBuyer.readMultiple(ids, targetCollectionName)
			),
		fetchWorkOrderPriorities: (
			params,
			targetCollectionName,
			pagination,
			sorting,
			filters,
			addToTargetCollection
		) =>
			dispatch(
				ownProps.userType === ROLE_TYPES.SUPPLIER
					? workOrderPrioritiesRestCrudThunksForSupplier.read(
							params,
							targetCollectionName || WORK_ORDERS_CALENDAR_TARGET_COLLECTION,
							pagination,
							sorting,
							filters,
							addToTargetCollection
					  )
					: workOrderPrioritiesRestCrudThunksForBuyer.read(
							params,
							targetCollectionName || WORK_ORDERS_CALENDAR_TARGET_COLLECTION,
							pagination,
							sorting,
							filters,
							addToTargetCollection
					  )
			),
		fetchAssetTypes: (
			params,
			targetCollectionName,
			pagination,
			sorting,
			filters,
			addToTargetCollection
		) =>
			dispatch(
				ownProps.userType === ROLE_TYPES.SUPPLIER
					? assetTypesRestCrudThunksForSupplier.readLite(
							{ ...params, no_pagination: true },
							targetCollectionName || WORK_ORDERS_CALENDAR_TARGET_COLLECTION,
							pagination,
							sorting,
							filters,
							addToTargetCollection
					  )
					: assetTypesRestCrudThunksForBuyer.readLite(
							{ ...params, no_pagination: true },
							targetCollectionName || WORK_ORDERS_CALENDAR_TARGET_COLLECTION,
							pagination,
							sorting,
							filters,
							addToTargetCollection
					  )
			),
		fetchMultipleAssetTypes: (ids, targetCollectionName) =>
			dispatch(
				ownProps.userType === ROLE_TYPES.SUPPLIER
					? assetTypesRestCrudThunksForSupplier.readMultiple(ids, targetCollectionName)
					: assetTypesRestCrudThunksForBuyer.readMultiple(ids, targetCollectionName)
			),
		fetchMultipleResolutionTypes: (ids, targetCollectionName) =>
			dispatch(
				ownProps.userType === ROLE_TYPES.SUPPLIER
					? resolutionTypesRestCrudThunksForSupplier.readMultiple(ids, targetCollectionName)
					: resolutionTypesRestCrudThunksForBuyer.readMultiple(ids, targetCollectionName)
			),
		fetchResolutionTypes: (
			params,
			targetCollectionName,
			pagination,
			sorting,
			filters,
			addToTargetCollection
		) =>
			dispatch(
				ownProps.userType === ROLE_TYPES.SUPPLIER
					? resolutionTypesRestCrudThunksForSupplier.read(
							params,
							targetCollectionName || WORK_ORDERS_CALENDAR_TARGET_COLLECTION,
							pagination,
							sorting,
							filters,
							addToTargetCollection
					  )
					: resolutionTypesRestCrudThunksForBuyer.read(
							params,
							targetCollectionName || WORK_ORDERS_CALENDAR_TARGET_COLLECTION,
							pagination,
							sorting,
							filters,
							addToTargetCollection
					  )
			),
		fetchProblemTypes: (
			params,
			targetCollectionName,
			pagination,
			sorting,
			filters,
			addToTargetCollection
		) =>
			dispatch(
				ownProps.userType === ROLE_TYPES.SUPPLIER
					? problemTypesHeirarchicalForSupplier(
							params,
							targetCollectionName || WORK_ORDERS_CALENDAR_TARGET_COLLECTION,
							pagination,
							sorting,
							filters,
							addToTargetCollection
					  )
					: problemTypesHeirarchicalForBuyer(
							params,
							targetCollectionName || WORK_ORDERS_CALENDAR_TARGET_COLLECTION,
							pagination,
							sorting,
							filters,
							addToTargetCollection
					  )
			),
		fetchSupplierFacilitiesInPrivateNetwork: (
			params,
			targetCollectionName,
			pagination,
			sorting,
			filters,
			addToTargetCollection
		) =>
			dispatch(
				ownProps.userType === ROLE_TYPES.SUPPLIER
					? fetchSupplierFacilitiesInPrivateNetworkForSupplier(
							params,
							targetCollectionName || WORK_ORDERS_CALENDAR_TARGET_COLLECTION,
							pagination,
							sorting,
							filters,
							addToTargetCollection
					  )
					: fetchSupplierFacilitiesInPrivateNetworkForBuyer(
							params,
							targetCollectionName || WORK_ORDERS_CALENDAR_TARGET_COLLECTION,
							pagination,
							sorting,
							filters,
							addToTargetCollection
					  )
			),
		fetchPMSchedule: (
			params,
			targetCollectionName,
			pagination,
			sorting,
			filters,
			addToTargetCollection
		) =>
			dispatch(
				ownProps.userType === ROLE_TYPES.SUPPLIER
					? plannedMaintenanceSchedulesRestCrudThunksForSupplier.read(
							params,
							targetCollectionName || WORK_ORDERS_CALENDAR_TARGET_COLLECTION,
							pagination,
							sorting,
							filters,
							addToTargetCollection
					  )
					: plannedMaintenanceSchedulesRestCrudThunksForBuyer.read(
							params,
							targetCollectionName || WORK_ORDERS_CALENDAR_TARGET_COLLECTION,
							pagination,
							sorting,
							filters,
							addToTargetCollection
					  )
			),
		fetchMultiplePMSchedule: (ids, targetCollectionName) =>
			dispatch(
				ownProps.userType === ROLE_TYPES.SUPPLIER
					? plannedMaintenanceSchedulesRestCrudThunksForSupplier.readMultiple(
							ids,
							targetCollectionName || WORK_ORDERS_CALENDAR_TARGET_COLLECTION
					  )
					: plannedMaintenanceSchedulesRestCrudThunksForBuyer.readMultiple(
							ids,
							targetCollectionName || WORK_ORDERS_CALENDAR_TARGET_COLLECTION
					  )
			),
		// Explicit large page: the calendar needs every location the user can see, because each one is
		// a column. The list endpoint otherwise defaults to 10.
		fetchCalendarLocations: () =>
			dispatch(
				locationsRestCrudThunks(ownProps.userType).read(
					{},
					SERVICE_CALENDAR_LOCATIONS_TARGET_COLLECTION,
					{ current: 1, pageSize: 1000 },
					{ sort_by: 'name', order: 'ascend' }
				)
			),
		fetchLocationTree: () =>
			dispatch(
				fetchLocationsWithRegionsAndSubRegions(ownProps.userType)(
					{},
					LOCATION_TREE_TARGET_COLLECTION,
					{ current: 1, pageSize: 1000 },
					{ sort_by: 'name', order: 'ascend' }
				)
			),
		fetchAllFieldTechs: () =>
			dispatch(
				fetchAllFieldTechs(ownProps.userType)(SERVICE_CALENDAR_TECHNICIANS_TARGET_COLLECTION)
			),
		fetchMultipleFieldTechs: (ids, targetCollectionName) =>
			dispatch(
				ownProps.userType === ROLE_TYPES.SUPPLIER
					? fieldTechsRestCrudThunksForSupplier.readMultiple(ids, targetCollectionName)
					: fieldTechsRestCrudThunksForBuyer.readMultiple(ids, targetCollectionName)
			),
		fetchFieldTechs: (
			params,
			targetCollectionName,
			pagination,
			sorting,
			filters,
			addToTargetCollection
		) =>
			dispatch(
				ownProps.userType === ROLE_TYPES.SUPPLIER
					? fieldTechsRestCrudThunksForSupplier.read(
							params,
							targetCollectionName,
							pagination,
							sorting,
							filters,
							addToTargetCollection
					  )
					: fieldTechsRestCrudThunksForBuyer.read(
							params,
							targetCollectionName,
							pagination,
							sorting,
							filters,
							addToTargetCollection
					  )
			),
		fetchSpendCategories: (
			params,
			targetCollectionName,
			pagination,
			sorting,
			filters,
			addToTargetCollection
		) =>
			dispatch(
				ownProps.userType === ROLE_TYPES.SUPPLIER
					? spendCategoriesRestCrudThunksForSupplier.read(
							params,
							targetCollectionName,
							pagination,
							sorting,
							filters,
							addToTargetCollection
					  )
					: spendCategoriesRestCrudThunksForBuyer.read(
							params,
							targetCollectionName,
							pagination,
							sorting,
							filters,
							addToTargetCollection
					  )
			),
		fetchMultipleSpendCategories: (ids, targetCollectionName) =>
			dispatch(
				ownProps.userType === ROLE_TYPES.SUPPLIER
					? spendCategoriesRestCrudThunksForSupplier.readMultiple(ids, targetCollectionName)
					: spendCategoriesRestCrudThunksForBuyer.readMultiple(ids, targetCollectionName)
			),
		fetchAssets: (
			params,
			targetCollectionName,
			pagination,
			sorting,
			filters,
			addToTargetCollection
		) =>
			dispatch(
				assetsRestReadThunk(
					ownProps.userType,
					{ ...params },
					targetCollectionName,
					pagination,
					sorting,
					filters,
					addToTargetCollection
				)
			),
		fetchMultipleAssets: (ids, targetCollectionName) =>
			dispatch(assetsRestReadThunk(ownProps.userType, { ids }, targetCollectionName)),
		fetchContractors: (
			params,
			targetCollectionName,
			pagination,
			sorting,
			filters,
			addToTargetCollection
		) =>
			dispatch(
				ownProps.userType === ROLE_TYPES.SUPPLIER
					? ContractorPrivateNetworksRestCrudThunksForSupplier.read(
							params,
							targetCollectionName,
							pagination,
							sorting,
							filters,
							addToTargetCollection
					  )
					: ContractorPrivateNetworksRestCrudThunksForBuyer.read(
							params,
							targetCollectionName,
							pagination,
							sorting,
							filters,
							addToTargetCollection
					  )
			),
		fetchAreasDistinct: (
			params,
			targetCollectionName,
			pagination,
			sorting,
			filters,
			addToTargetCollection
		) =>
			dispatch(
				fetchDistinctAreasHeirarchy(ownProps.userType)(
					{ ...params, no_pagination: true },
					targetCollectionName,
					pagination,
					sorting,
					filters,
					addToTargetCollection
				)
			),

		fetchContractorClients: (
			params,
			targetCollectionName,
			pagination,
			sorting,
			filters,
			addToTargetCollection
		) =>
			dispatch(
				ownProps.userType === ROLE_TYPES.SUPPLIER
					? contractorClientsRestCrudThunksForSupplier.read(
							{ ...params },
							targetCollectionName,
							pagination,
							sorting,
							filters,
							addToTargetCollection
					  )
					: contractorClientsRestCrudThunksForBuyer.read(
							{ ...params },
							targetCollectionName,
							pagination,
							sorting,
							filters,
							addToTargetCollection
					  )
			),
		fetchMultipleContractorClients: (ids, targetCollectionName) =>
			dispatch(
				ownProps.userType === ROLE_TYPES.SUPPLIER
					? contractorClientsRestCrudThunksForSupplier.readMultiple(ids, targetCollectionName)
					: contractorClientsRestCrudThunksForBuyer.readMultiple(ids, targetCollectionName)
			),
		fetchContractorLocations: (
			params,
			targetCollectionName,
			pagination,
			sorting,
			filters,
			addToTargetCollection
		) =>
			dispatch(
				ownProps.userType === ROLE_TYPES.SUPPLIER
					? contractorLocationsRestCrudThunksForSupplier.read(
							{ ...params },
							targetCollectionName,
							pagination,
							sorting,
							filters,
							addToTargetCollection
					  )
					: contractorLocationsRestCrudThunksForBuyer.read(
							{ ...params },
							targetCollectionName,
							pagination,
							sorting,
							filters,
							addToTargetCollection
					  )
			),
		fetchMultipleContractorLocations: (ids, targetCollectionName) =>
			dispatch(
				ownProps.userType === ROLE_TYPES.SUPPLIER
					? contractorLocationsRestCrudThunksForSupplier.readMultiple(ids, targetCollectionName)
					: contractorLocationsRestCrudThunksForBuyer.readMultiple(ids, targetCollectionName)
			),
		// Same lookup the work order table uses (WorkOrderTable/index.tsx:687). Branching on the user
		// rather than the role is deliberate: an internal tech has a supplier userType but belongs to a
		// buyer's private team, so they need buyer_internal_team_users_list too. The bare
		// contactsRestCrudThunksFor{Buyer,Supplier} carry `common_contacts` with no sub-path, so their
		// `.read` resolves to a route that exists on neither persona — an empty Created by list.
		fetchUsers: (
			params,
			targetCollectionName,
			pagination,
			sorting,
			filters,
			addToTargetCollection
		) =>
			dispatch(
				isBuyerOrInternalTech(ownProps.currentUser)
					? getContactsWithInternalTechs(ownProps.userType).read(
							params,
							targetCollectionName,
							pagination,
							sorting,
							filters,
							addToTargetCollection
					  )
					: getContactsForThirdPartySuppliers.read(
							params,
							targetCollectionName,
							pagination,
							sorting,
							filters,
							addToTargetCollection
					  )
			),
		fetchMultipleUsers: (emails, targetCollectionName) =>
			dispatch(
				isBuyerOrInternalTech(ownProps.currentUser)
					? getContactsWithInternalTechs(ownProps.userType).read({ emails }, targetCollectionName)
					: getContactsForThirdPartySuppliers.read({ emails }, targetCollectionName)
			),
		fetchBrands: (
			params,
			targetCollectionName,
			pagination,
			sorting,
			filters,
			addToTargetCollection
		) =>
			dispatch(
				ownProps.userType === ROLE_TYPES.SUPPLIER
					? brandsRestCrudThunksForSupplier.read(
							params,
							targetCollectionName,
							pagination,
							sorting,
							filters,
							addToTargetCollection
					  )
					: brandsRestCrudThunksForBuyer.read(
							params,
							targetCollectionName,
							pagination,
							sorting,
							filters,
							addToTargetCollection
					  )
			),
		fetchMultipleBrands: (ids, targetCollectionName) =>
			dispatch(
				ownProps.userType === ROLE_TYPES.SUPPLIER
					? brandsRestCrudThunksForSupplier.readMultiple(ids, targetCollectionName)
					: brandsRestCrudThunksForBuyer.readMultiple(ids, targetCollectionName)
			),
		// Supplier-only on purpose. Scheduling a service call assigns a technician, which the buyer's
		// location view has no columns for — it disables dragging and hides the schedule drawer, so
		// neither of these is reachable there. There is also no rescheduleServiceCallForBuyer thunk.
		rescheduleServiceCall: (serviceCall) => dispatch(rescheduleServiceCallForSupplier(serviceCall)),
		scheduleServiceCall: (serviceCall) => dispatch(scheduleServiceCallForSupplier(serviceCall)),
		getFullWorkOrder: (id) =>
			dispatch(
				ownProps.userType === ROLE_TYPES.SUPPLIER
					? workOrdersRestCrudThunksForSupplier.readOne(id)
					: workOrdersRestCrudThunksForBuyer.readOne(id)
			),
		syncScheduleTechnicianFilter: (filters) =>
			dispatch(
				updateFiltersWorkOrders(ownProps.userType)(
					false, // handleQueryParams
					ownProps.history,
					WORK_ORDERS_SCHEDULE_TARGET_COLLECTION,
					filters,
					true // ignoreRefreshCounts for schedule table
				)
			),
	};
};

export default withRouter(
	withUserType(
		withCurrentUser(
			connect(mapStateToProps, mapDispatchToProps)(SupplierServiceCallCalendarPageV2 as any)
		)
	)
);
